import { formatBytes } from "@/shared/bytes";

export type LibraryDocumentView = {
  id: string;
  fileName: string;
  title: string | null;
  author: string | null;
  byteLength: number;
  pageCount: number;
  pdfAvailability: "stored" | "external";
  lastOpenedAt: string;
};

type Props = {
  document: LibraryDocumentView;
  busy?: boolean;
  onOpen(document: LibraryDocumentView): void;
  onLocate(document: LibraryDocumentView): void;
  onExport(document: LibraryDocumentView): void;
  onRemoveLocalCopy(document: LibraryDocumentView): void;
  onDelete(document: LibraryDocumentView): void;
};

export function DocumentRow({
  document,
  busy = false,
  onOpen,
  onLocate,
  onExport,
  onRemoveLocalCopy,
  onDelete,
}: Props) {
  const opened = new Intl.DateTimeFormat(undefined, {
    month: "short",
    day: "numeric",
    year:
      new Date(document.lastOpenedAt).getFullYear() ===
      new Date().getFullYear()
        ? undefined
        : "numeric",
  }).format(new Date(document.lastOpenedAt));

  return (
    <article className="document-row">
      <button
        className="document-primary"
        type="button"
        disabled={busy}
        onClick={() =>
          document.pdfAvailability === "stored"
            ? onOpen(document)
            : onLocate(document)
        }
      >
        <span className="document-glyph" aria-hidden="true">
          <span />
          PDF
        </span>
        <span className="document-copy">
          <span className="document-title">
            {document.title || document.fileName.replace(/\.pdf$/i, "")}
          </span>
          <span className="document-meta">
            {document.author ? `${document.author} · ` : ""}
            {document.pageCount} {document.pageCount === 1 ? "page" : "pages"}{" "}
            · {formatBytes(document.byteLength)} · opened {opened}
          </span>
        </span>
        <span
          className={`availability availability-${document.pdfAvailability}`}
        >
          {document.pdfAvailability === "stored"
            ? "Ready offline"
            : "Locate PDF"}
        </span>
      </button>

      <div className="document-actions">
        <button
          type="button"
          disabled={busy}
          onClick={() => onExport(document)}
        >
          Export notes
        </button>
        {document.pdfAvailability === "stored" ? (
          <button
            type="button"
            disabled={busy}
            onClick={() => onRemoveLocalCopy(document)}
          >
            Remove PDF copy
          </button>
        ) : null}
        <button
          className="danger-link"
          type="button"
          disabled={busy}
          onClick={() => onDelete(document)}
        >
          Delete
        </button>
      </div>
    </article>
  );
}
